import router from '@/router';
import { LocationQueryRaw } from 'vue-router';

function pageRedirect(path: string, query?: LocationQueryRaw) {
  if (!path.startsWith('/')) {
    path = `/${path}`;
  }
  router.replace({ path, query });
}

export default pageRedirect;
